import {
  Options,
  Splide,
  SplideSlide,
  SplideTrack
} from '@splidejs/react-splide'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'
import clsx from 'clsx'
import { FC, useRef } from 'react'

import DefaultComponentProps from '@/types/DefaultComponentProps'

import BigoAds from '../../../public/images/partners/bigo-ads.svg'
import GoogleAds from '../../../public/images/partners/google-ads.svg'
import Meta from '../../../public/images/partners/meta.svg'
import Petal from '../../../public/images/partners/petal-ads.svg'
import SearchAds from '../../../public/images/partners/search-ads.svg'
import Snapchat from '../../../public/images/partners/snapchat.svg'
import Telegram from '../../../public/images/partners/telegram.svg'
import TikTok from '../../../public/images/partners/tik-tok.svg'

import styles from './Partners.module.scss'

const PARTNERS = [
  {
    name: 'Facebook',
    Icon: Meta
  },
  {
    name: 'Snapchat',
    Icon: Snapchat
  },

  {
    name: 'BigoAds',
    Icon: BigoAds
  },

  {
    name: 'TikTok',
    Icon: TikTok
  },

  {
    name: 'Google Ads',
    Icon: GoogleAds
  },
  {
    name: 'Telegram',
    Icon: Telegram
  },

  {
    name: 'Petal Ads',
    Icon: Petal
  },

  {
    name: 'Apple Search Ads',
    Icon: SearchAds
  }
]

const OPTIONS: Options = {
  autoHeight: true,
  autoWidth: true,
  arrows: false,
  classes: {
    pagination: `splide__pagination ${styles['partners__splide-pagination']}`,
    page: `splide__pagination__page  ${styles['partners__splide-page']}`
  },
  pagination: false,
  mediaQuery: 'min',
  type: 'loop',
  drag: false,
  focus: 'center',
  gap: '4.8rem',
  autoScroll: {
    speed: 1,
    pauseOnHover: false
  }
}

const PartnersCarousel: FC<DefaultComponentProps> = ({ className = '' }) => {
  const splideRef = useRef<Splide>(null)

  return (
    <div className={clsx(styles['partners'], className)}>
      <Splide
        ref={splideRef}
        hasTrack={false}
        options={OPTIONS}
        extensions={{ AutoScroll }}
      >
        <SplideTrack>
          {PARTNERS.map(({ name, Icon }, index) => (
            <SplideSlide
              role={'section'}
              key={name + index}
              className={styles['partners__item']}
            >
              <div className={styles['partners__fig']}>
                <Icon />
              </div>
            </SplideSlide>
          ))}
        </SplideTrack>
      </Splide>
    </div>
  )
}
export default PartnersCarousel
